import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { AbstractControl, FormGroup, FormBuilder, Validators, ValidationErrors } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericValidationsService } from 'src/app/Service/generic-validations.service';
import { SevaProfileService } from 'src/app/Service/seva-profile.service';
import { TranslationService } from 'src/app/Service/translation.service';
import { CONSTANTS, INDIAN_STATES, RELATIONSHIP_OPTIONS } from '../../../../Core/Constant';
import { COUNTRY_DIAL_CODES } from 'src/Core/CountryCodes';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'app-imergency-contact-detail',
  templateUrl: './imergency-contact-detail.component.html',
  styleUrls: ['./imergency-contact-detail.component.scss']
})
export class ImergencyContactDetailComponent {
  @Input() applicantData: any; // Accept data from parent component
  @Input() isPreviewMode: boolean = false; // Flag to determine behavior
  @Output() formGroupChange = new EventEmitter<FormGroup>();
  @Output() nextStep = new EventEmitter<void>();
  @Output() previous = new EventEmitter<void>();

  residentialAddressForm!: FormGroup;
  submitted = false;
  SaveMode = CONSTANTS.SAVE_MODE;
  isJsonShow = environment.isJsonShow;  // Set isJsonShow from the environment
  relationshipOptions = RELATIONSHIP_OPTIONS;
  indianStateOptions = INDIAN_STATES;
  selectedLanguage: string = 'en'; // Default language
  countryCodeOptions = COUNTRY_DIAL_CODES;
  private currentAddressMobile?: string;
  private currentAddressCountryCode?: string;



  constructor(
    private toastr: ToastrService, 
    private api: SevaProfileService, 
    private fb: FormBuilder, 
    public genericValidations: GenericValidationsService,
    private translationService: TranslationService
  ) { }

  ngOnInit(): void {
    // Load saved language preference
    this.selectedLanguage = this.translationService.getCurrentLanguage();

    // Ensure current address contact details are available for comparison
    this.loadCurrentAddressContact();

  //   if (!this.isPreviewMode) {
  //     // Execute only when not in preview mode
  //   this.initializeForm();
  //   this.getApplicantData();
    
  // }
}

  // Get translation for current language
  getTranslation(key: string): string {
    return this.translationService.getTranslation(key);
  }


ngOnChanges(changes: SimpleChanges): void {
  if (changes['applicantData'] && this.applicantData) {

    this.initializeForm();
    this.residentialAddressForm.patchValue(this.applicantData);
    this.setMobileValidatorsForCode(this.residentialAddressForm.get('CountryCode')?.value || '+91');
    
    if (this.isPreviewMode) {

    this.residentialAddressForm.disable();
    }
  }
}

  getApplicantData(){
    this.api.getById('Address/GetAddress?addressTyp', { addressType:  CONSTANTS.AddressType.Emergency }).subscribe((response: any) => {
      if (response.Data && Object.keys(response.Data).length > 0) {

        this.genericValidations.setProgressPercentage(response.Data.CompletionPercentage); // Example: Set progress to 50%


        this.residentialAddressForm.patchValue(response.Data);
      }
    })
  }


  initializeForm() {
    this.residentialAddressForm = this.fb.group({
      EMERGENCYContactName: ['', Validators.required],
      EMERGENCYContacRelationship: ['', Validators.required],
      WorkPhone: ['', Validators.pattern(/^[0-9]{10}$/)],
      CountryCode: ['+91', Validators.required],
      Mobile: ['', [
        Validators.required,
        Validators.pattern(/^[7-9][0-9]{9}$/),
        Validators.maxLength(10),
        this.disallowSameAsCurrentMobile()
      ]],
      Email: ['', [ Validators.email]],
      AddressType: [2, [Validators.required]],
      SaveMode: ['', [Validators.required,]],
    });

    this.setMobileValidatorsForCode(this.residentialAddressForm.get('CountryCode')?.value || '+91');
    this.formGroupChange.emit(this.residentialAddressForm);
  }

  onCountryCodeChange(selection: any): void {
    const code = typeof selection === 'string' ? selection : selection?.code || '';
    this.residentialAddressForm.patchValue({ CountryCode: code });
    this.setMobileValidatorsForCode(code);
  }

  searchCountry = (term: string, item: { code: string; country: string }) => {
    const value = term?.toLowerCase().trim();
    if (!value) return true;
    return (
      item.code.toLowerCase().includes(value) ||
      item.country.toLowerCase().includes(value)
    );
  };

  private setMobileValidatorsForCode(code: string): void {
    const mobileCtrl = this.residentialAddressForm.get('Mobile');

    if (code === '+91') {
      mobileCtrl?.setValidators([
        Validators.required,
        Validators.pattern('^[7-9][0-9]{9}$'),
        Validators.maxLength(10),
        this.disallowSameAsCurrentMobile()
      ]);
    } else {
      mobileCtrl?.setValidators([
        Validators.required,
        Validators.pattern('^[0-9]{8,15}$'),
        Validators.maxLength(15),
        this.disallowSameAsCurrentMobile()
      ]);
    }

    mobileCtrl?.updateValueAndValidity();
  }

  onSubmit(Mode: number,Parent: string): void {

    this.residentialAddressForm.patchValue({
      SaveMode: Mode
    })

    if (!this.residentialAddressForm.valid && Mode ==  this.SaveMode.SAVE) {
      this.submitted = true;

                       // Add 'submitted' class manually to all invalid controls
    Object.keys(this.residentialAddressForm.controls).forEach((field) => {
      const control = this.residentialAddressForm.get(field);
      if (control && control.invalid) {
        control.markAsTouched(); // Ensure ng-touched is triggered
        const element = document.getElementById(field);
        if (element) {
          element.classList.add('submitted'); // Add 'submitted' class to invalid elements
        }
      }
    });

    this.toastr.warning(this.getTranslation('validation.completeAllFields'));

      return
    }

    const cleanedValues = this.genericValidations.removeWhitespaceFromValues(this.residentialAddressForm.value);
    this.addUpdate(cleanedValues, Mode,Parent);

  }

  addUpdate(reqBoby: any, Mode: number,Parent: string) {
    this.api.apiCall('Address/SaveAddress', 'POST', reqBoby).subscribe((response: any) => {
      console.log('POST response:', response);
      if(Parent == 'CHILD'){
        this.toastr.success( response?.Message);
      }
      if (Mode ==  this.SaveMode.SAVE) {
        this.nextStep.emit();
      }else if(Mode ==  this.SaveMode.DRAFT){
        this.getApplicantData();
      }
    });
  }

  goToBack() {
    this.previous.emit();
  }

  private loadCurrentAddressContact(): void {
    this.api.getById('Address/GetAddress?addressTyp', { addressType: CONSTANTS.AddressType.Current }).subscribe((response: any) => {
      if (response?.Data) {
        this.currentAddressMobile = response.Data.Mobile;
        this.currentAddressCountryCode = response.Data.CountryCode;
        // Re-validate in case user already entered a value
        this.residentialAddressForm?.get('Mobile')?.updateValueAndValidity();
      }
    });
  }

  private disallowSameAsCurrentMobile() {
    return (control: AbstractControl): ValidationErrors | null => {
      const code = this.residentialAddressForm?.get('CountryCode')?.value;
      if (!control || !this.currentAddressMobile || !code) {
        return null;
      }

      const sameCode = code === (this.currentAddressCountryCode || '');
      const sameMobile = control.value && control.value === this.currentAddressMobile;
      return sameCode && sameMobile ? { sameAsCurrentMobile: true } : null;
    };
  }

  onSameAsResidentialAddressChange(event: Event): void {
    const isChecked = (event.target as HTMLInputElement).checked;

    if (isChecked) {


 
        this.api.getById('Address/GetAddress?addressTyp', { addressType: CONSTANTS.AddressType.Current }).subscribe((response: any) => {
          if (response.Data && Object.keys(response.Data).length > 0) {
            // this.residentialAddressForm.patchValue(response.Data);
            
      const residentialAddress = {
        // Assuming these values are populated in your residential address form
        
        // StreetAddress: response.Data.StreetAddress,
        // TownCity: response.Data.TownCity,
        // District: response.Data.District,
        // State: response.Data.State,
        // PinCode: response.Data.PinCode,
        // Mobile: response.Data.Mobile,
        Email: response.Data.Email,
        // HomePhone:response.Data.HomePhone
      };

      this.residentialAddressForm.patchValue(residentialAddress);
          }
        })
      
    

   

   
    } else {
      this.residentialAddressForm.patchValue({
        // EMERGENCYContactName: '',
        // StreetAddress: '',
        // TownCity: '',
        // District: '',
        // State: '',
        // PinCode: '',
        Mobile: '',
        Email: ''
      });
    }
  }

}
